import { IcdCorporationManager } from '@herbjoy/apex-api-models';
import { IComponentOptions } from 'angular';
import { EventEmitter } from '../../common/components/event-emitter';
import templateUrl from './corporation-manager-list.component.html'

export const CorporationManagerListComponent: IComponentOptions = {
    bindings: {
        name: "<",
        managers: "<",
        deleteManager: "&onDeleteManager"
    },
    controller: class CorporationManagerListController {
        name: string;
        managers: IcdCorporationManager[];
        deleteManager: EventEmitter<any>;

        pageNumber = 1;
        pageSize = 10;

        onSearch() {
            this.pageNumber = 1;
        }
    },
    controllerAs: "vm",
    templateUrl
};
